<!--
  Copyright (c) 2023-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<gm-loading-block [target]="helpPnl" [blocked]="(loading)" label="Loading"></gm-loading-block>
<p-panel #helpPnl>
  <form  [formGroup]="helpInfoForm">
    @if (!(editEnabled)) {
      <div style="height: 80vh">
        @if (allowedToEditHelpInfo()) {
          <p-button gmTertiary label="Edit" class="mr-2" (onClick)="toggleEditor()" ></p-button>
        }
        <div [innerHTML]="(helpMessage)"></div>
      </div>
    }
    @if ((editEnabled)) {
      <div>
        <div class="button-row">
          <p-button gmPrimary label="Save" (onClick)="saveHelpInfo()"></p-button>
          <p-button gmSecondary label="Cancel" (onClick)="toggleEditor()"></p-button>
        </div>
        <p-editor formControlName="helpInfoEditor" [style]="{'height':'500px'}"></p-editor>
        <div class="button-row" style="margin-top: 12px">
          <p-button gmPrimary label="Save" (onClick)="saveHelpInfo()"></p-button>
          <p-button gmSecondary label="Cancel" (onClick)="toggleEditor()"></p-button>
        </div>
      </div>
    }
  </form>
</p-panel>


